import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { firstValueFrom, Subject, takeUntil } from 'rxjs'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from 'src/app/core/models'

@Injectable()
export class DataWebcamsService {
  private cancelPreviousRequests = new Subject<void>()
  constructor(
    private readonly http: HttpClient,
    @Inject(APP_CONFIG) private readonly config: AppConfigModel,
  ) {}

  async loadWebcamsJson() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }
    const url = `${this.config.backend_url}rcs/webcams`
    const result = await firstValueFrom(
      this.http.get<any>(url.toString(), httpOptions).pipe(takeUntil(this.cancelPreviousRequests)),
    )
    return result
  }

  /**
   * Cancels all pending requests by emitting the destroy signal.
   */
  cancelCurrentRequests(): void {
    this.cancelPreviousRequests.next()
  }
}
